import { createUseStyles } from 'react-jss';
import { hexToRgb } from '../../utils';
export default createUseStyles((theme) => ({
    container: {
        borderRadius: '50%',
        outline: 'none',
        border: 'none',
        overflow: 'hidden',
        boxSizing: 'border-box',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 1,
        backgroundColor: 'transparent',
        boxShadow: theme.elevation.iconButton,
        '& > span': { zIndex: 2 }
    },
    contained_default: {
        backgroundColor: theme.palette.grey[12]
    },
    outlined_default: Object.assign({}, generatePseudos(theme.palette.grey[12])),
    contained_disabled: {
        pointerEvents: 'none',
        backgroundColor: `${theme.palette.grey[2]} !important`,
        color: theme.palette.grey[8],
        boxShadow: 'none'
    },
    outlined_disabled: {
        pointerEvents: 'none',
        borderColor: `${theme.palette.grey[2]} !important`,
        color: theme.palette.grey[8],
        backgroundColor: 'transparent',
        boxShadow: 'none'
    },
    active: {
        '&::after': {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            content: "' '",
            backgroundColor: 'rgba(0,0,0,.2) !important',
        },
    },
    outlined: {
        border: `2px solid ${theme.palette.grey[8]}`,
        backgroundColor: 'white'
    },
    primary: Object.assign({ borderColor: theme.palette.primary.dark }, generatePseudos(theme.palette.primary.regular)),
    secondary: Object.assign({ borderColor: theme.palette.secondary.dark }, generatePseudos(theme.palette.secondary.regular)),
    success: Object.assign({ borderColor: theme.palette.success.regular }, generatePseudos(theme.palette.success.regular)),
    warning: Object.assign({ borderColor: theme.palette.warning.regular }, generatePseudos(theme.palette.warning.regular)),
    danger: Object.assign({ borderColor: theme.palette.danger.regular }, generatePseudos(theme.palette.danger.regular)),
    contained: {
        '&:active': {
            '&::after': {
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                content: "' '",
                backgroundColor: 'rgba(0,0,0,.2)',
            },
        },
        '&:hover': {
            '&::after': {
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                content: "' '",
                backgroundColor: 'rgba(0,0,0,.1)',
            },
        },
    },
    primary_contained: { backgroundColor: theme.palette.primary.regular },
    secondary_contained: { backgroundColor: theme.palette.secondary.regular },
    success_contained: { backgroundColor: theme.palette.success.regular },
    warning_contained: { backgroundColor: theme.palette.warning.regular },
    danger_contained: { backgroundColor: theme.palette.danger.regular },
}));
const generatePseudos = color => ({
    '&:active': {
        '&::after': {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            content: "' '",
            backgroundColor: `${hexToRgb(color, true, .2)}`,
        },
    },
    '&:hover': {
        '&::after': {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            content: "' '",
            backgroundColor: `${hexToRgb(color, true, .1)}`,
        },
    },
});
//# sourceMappingURL=styles.js.map